import React from 'react';
import Button from '../../../../components/common/button/button';
import Icon, { IconNames } from '../../../../components/common/icon/icon';
import styles from './header-button.scss';
import { Tooltip } from '../../../../components/common';

interface Props {
  hint: string;
  icon: IconNames;
  onClick(): void;
}

export class HeaderButton extends React.Component<Props> {
  private onClick() {
    this.props.onClick();
  }

  public render() {
    const { hint, icon } = this.props;

    return (
      <Tooltip content={hint} theme="dark" moveBy={{ y: -5 }}>
        <span>
          <Button
            theme="icon-whitesecondary"
            height="small"
            onClick={this.onClick.bind(this)}
            dataHook="accordion-item-header-button"
          >
            <Icon name={icon} className={styles.titleIcon} />
          </Button>
        </span>
      </Tooltip>
    );
  }
}
